module.exports = __webpack_public_path__ + "img/recommend.48d45e06.png";